(function ($) {
    'use strict';

    // Map: Gravity Form ID → extra button class
    const formButtonClassMap = {
        1: 'btn-white',
        2: 'btn-white',
        3: 'btn-blue',
        4: 'btn-blue'
    };

    // --- small debounce to avoid thrashing during rapid DOM updates
    function debounce(fn, wait) {
        let t;
        return function () {
            clearTimeout(t);
            const ctx = this, args = arguments;
            t = setTimeout(function () { fn.apply(ctx, args); }, wait);
        };
    }

    function replaceAllGformButtons(root) {
        const $root = root ? $(root) : $(document);

        // Only target native GF submit INPUTs that haven't been replaced yet
        $root.find('input.gform_button[type="submit"]').not('.__replaced').each(function () {
            const $input = $(this).addClass('__replaced');

            const buttonText  = $input.val() || '';
            const buttonId    = $input.attr('id') || ''; // usually gform_submit_button_{ID}
            const onClick     = $input.attr('onclick');
            const formWrapper = $input.closest('.gform_wrapper');
            const wrapperId   = formWrapper.attr('id') || '';
            const match       = /gform_wrapper_(\d+)/.exec(wrapperId);
            const formId      = match ? parseInt(match[1], 10) : null;

            const extraClass = (formId && formButtonClassMap[formId]) ? formButtonClassMap[formId] : '';

            // Keep 'gform_button' so GF continues to bind any behaviors to the submit control
            const cleanedClasses = String($input.attr('class') || '')
                .replace(/\s+__replaced\b/g, '') // remove temp flag
                .replace(/\s+/g, ' ')
                .trim();

            // Build the new button (keep gform_button!)
            const $customButton = $('<button/>', {
                type: 'submit',
                id: buttonId,
                // Keep GF class + add your classes
                class: `gform_button btn btn-primary ${extraClass} ${cleanedClasses}`.trim(),
                'data-gf-replaced': 'true'
            }).append($('<span/>').text(buttonText));

            if (onClick) $customButton.attr('onclick', onClick);

            // Preserve useful attributes
            ['name','tabindex','title','aria-label','aria-describedby','data-submission-type','disabled','form','value']
                .forEach(attr => {
                    const val = $input.attr(attr);
                    if (val != null) $customButton.attr(attr, val);
                });

            $input.replaceWith($customButton);
        });
    }

    // Attach a MutationObserver to each form wrapper to catch GF swaps after validation
    function observeWrapper($wrapper) {
        if (!$wrapper.length || $wrapper.data('gf-observing')) return;

        const debouncedReplace = debounce(() => replaceAllGformButtons($wrapper), 10);
        const observer = new MutationObserver(function (mutations) {
            // If any INPUT submit appears (GF re-render), replace again
            const needsReplace = mutations.some(m =>
                Array.from(m.addedNodes || []).some(n =>
                    n.nodeType === 1 && (
                        n.matches?.('input.gform_button[type="submit"]') ||
                        $(n).find('input.gform_button[type="submit"]').length
                    )
                )
            );
            if (needsReplace) debouncedReplace();
        });

        observer.observe($wrapper[0], { childList: true, subtree: true });
        $wrapper.data('gf-observing', true);
    }

    function init() {
        replaceAllGformButtons();
        $('.gform_wrapper').each(function () { observeWrapper($(this)); });
    }

    // Track form submissions via dataLayer
    function trackFormSubmission(formId) {
        // Get page information
        var pageInfo = {
            url: window.location.href,
            title: document.title,
            referrer: document.referrer || ''
        };

        // Build dataLayer object
        var dataLayerEvent = {
            event: 'form_submit_successful',
            form_id: formId,
            page_info: pageInfo,
            timestamp: Date.now(),
            event_category: 'form',
            event_action: 'submit',
            event_label: 'Form ' + formId,
            source_url:  window.location.href
        };

        // Push to dataLayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(dataLayerEvent);

        // Log for debugging (remove in production)
        if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
            console.log('Form submission tracked:', dataLayerEvent);
        }
    }

    // Initial run
    $(init);

    // Re-run after GF AJAX renders, page changes, and conditional logic updates
    // (We use both the event listener and the GF hook API for robustness)
    $(document).on('gform_post_render', function (e, formId) {
        init();
    });
    $(document).on('gform_page_loaded', function (e, formId) {
        init();
    });
    $(document).on('gform_post_conditional_logic', function (e, formId) {
        init();
    });
    $(document).on('gform_confirmation_loaded', function(event, formId) {
        trackFormSubmission(formId);
    });

    if (window.gform && typeof gform.addAction === 'function') {
        gform.addAction('gform_post_render', function () { init(); });
        gform.addAction('gform_page_loaded', function () { init(); });
        gform.addAction('gform_post_conditional_logic', function () { init(); });
    }
}(jQuery));
